var path = '/templates/projects.campaigns/show_incentive.html';
var html = "<zc-campaign-incentive-table campaign=campaign></zc-campaign-incentive-table><zc-campaign-incentive-error campaign=campaign form=incentiveForm></zc-campaign-incentive-error><zc-campaign-incentive-warning campaign=campaign></zc-campaign-incentive-warning><div ng-if=!campaign.incentives.length><div class=big_icon><i class=\"fa fa-ticket\"></i></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../enterprise/src/zenclerk_modules/projects.campaigns/show_incentive.html
// module id = 1397
// module chunks = 0